module.exports = __webpack_public_path__ + "img/A2-czech-republic.fb00779c.png";